import React from "react";
import { OverlayTrigger, Tooltip as BTooltip } from "react-bootstrap";

export interface IProps {
  text: JSX.Element | JSX.Element[] | string | string[];
  children: any;
  placement?: "left" | "right" | "top" | "bottom";
}

export const Tooltip = ({
  text,
  children,
  placement = "right",
  ...props
}: IProps): JSX.Element => {
  return (
      <OverlayTrigger
        placement={placement}
        overlay={<BTooltip id="tooltip">{text}</BTooltip>}
        {...props}
      >
        {children}
      </OverlayTrigger>
  );
};
